









































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import {
  FourVolumeData, emptyFourVolume, putVolume
} from '@/api/heritageUnit/unitFour'
import { UploadOptData, thumbnailServer } from '@/api/common/upload'
import { showVaildMsg } from '@/configs/validate'
import * as attApi from '@/api/common/attach'
import { newGuid } from '@/configs/functions'
import singleFile from '@/components/upload/singleFile.vue'
import { imageFormat } from '@/configs/fileTypes'
import Element from 'element-ui'
import FormDialog from '@/components/dialog/formDialog.vue'

const getFormRules = (form: { [key: string]: string }) => {
  return {
    Name: [{ required: true, message: '请输入提名', trigger: 'blur' }]
  }
}
@Component({
  components: { FormDialog, singleFile }
})
export default class UnitFourVolumeForm extends Vue {
  public name = 'UnitFourVolumeForm'
  public expandNames: string[] = ['info']
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false

  public fileExt = imageFormat + '.doc.docx.pdf'
  /*
  主卷：101调查发掘 102防治监测 103文物展示 104电子文件 199续补卷 新加的：105文字卷 106保护规划及保护工程方案
  副卷：201行政管理 202法律文书 203大事记 299续补卷
  备考卷：301参考资料 302论文卷 303图书卷 399续补卷
  */
  get categoryName(): String {
    var categories = [
      { Key: 101, Name: '调查发掘' },
      { Key: 102, Name: '防治监测' },
      { Key: 103, Name: '文物展示' },
      { Key: 104, Name: '电子文件' },
      { Key: 105, Name: '文字卷' },
      { Key: 106, Name: '保护规划及保护工程方案' },
      { Key: 199, Name: '续补卷' },
      { Key: 201, Name: '行政管理' },
      { Key: 202, Name: '法律文书' },
      { Key: 203, Name: '大事记' },
      { Key: 299, Name: '续补卷' },
      { Key: 301, Name: '参考资料' },
      { Key: 302, Name: '论文卷' },
      { Key: 303, Name: '图书卷' },
      { Key: 399, Name: '续补卷' }
    ]
    var item = categories.find(v => v.Key == this.form.Category)
    return item ? item.Name : ''
  }
  public refTarget: string = ''
  public form: FourVolumeData = Object.assign({}, emptyFourVolume)
  public rules = getFormRules(this.form)

  public $refs!: {
    formData: Element.Form
  }
  public getFileUrl(f: attApi.AttachInfo) {
    return thumbnailServer(f.Id, f.TempGuid, f.Name)
  }
  public created() {
    // this.rules = getFormRules(this.form)
  }
  public loading: boolean = false
  public mounted() {
    window.eventBus.$on('openUnitFourVolumeForm', (info: any) => {
      this.refTarget = info.targetId
      this.setData(info.data)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('openUnitFourVolumeForm')
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public setData(info: FourVolumeData) {
    this.open()
    this.loading = true
    if (info.AttachId == 0 && info.AttachGuid == '') {
      info.AttachGuid = newGuid()
    }
    this.form = Object.assign({}, info)

    setTimeout(() => {
      this.loading = false
    }, 500)
  }
  public sendData(data: FourVolumeData) {
    window.eventBus.$emit('submitUnitFourVolumeForm', {
      targetId: this.refTarget,
      data: data
    })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        var f = Object.assign({}, this.form)
        if (f.AttachId == 0) {
          this.$message({
            message: `请上传图片!`,
            type: 'warning'
          })
          return false
        } else {
          putVolume(f.Id, f).then(
            (response: { data: any }) => {
              const data = response.data
              const msg = f.Id > 0 ? '保存' : '创建'
              if (data && !data.IsError) {
                this.$message({
                  message: `${msg}成功`,
                  type: 'success'
                })
                //如果是新增，需要获取新增后的Id
                f.Id = data.DataId
                this.sendData(f)
                this.close()
              } else {
                this.$message({
                  dangerouslyUseHTMLString: true, message: `${data.Message}`,
                  type: 'warning'
                })
              }
            },
            (data: any) => {
              console.log(data)
            }
          )
        }
      } else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
  public onFileChange(data: { opts: UploadOptData, file: attApi.AttachInfo }) {
    var attInfo = data.file
    this.form.AttInfo = attInfo
    this.form.AttachId = attInfo.Id
    if (this.form.Name == '') {
      const fileName = attInfo.Name
      //去掉后缀名
      var name = fileName.substr(0, fileName.lastIndexOf('.'))
      this.form.Name = name
    }
  }
  public onFileClick(data: { opts: UploadOptData, file: attApi.AttachInfo }) {
    console.log('onFileClick', data)
  }

}
